'use client'

import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import GradientText from '@/components/reactbits/gradient_text';

interface InterstitialLoadingProps {
  title: string;
  subtitle?: string;
}

const InterstitialLoading: React.FC<InterstitialLoadingProps> = ({ title, subtitle }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black"
    >
      <div className="text-center space-y-4">
        <GradientText
          colors={["#E8A5FF", "#A571FC"]}
          className="lg:text-3xl text-2xl font-bold"
        >
          {title}
        </GradientText>
        {subtitle && <p className="lg:text-xl text-smmd text-gray-300">{subtitle}</p>}
        <Loader2 className="h-7 w-7 animate-spin text-purple-200 mx-auto mt-6" />
      </div>
    </motion.div>
  );
};

export default InterstitialLoading; 